import React, { createContext, ReactNode, useContext, useState } from 'react';

interface ToggledSwitchesContextType {
  schoolId:string
  setSchoolId: React.Dispatch<React.SetStateAction<string>>;
  schoolCount:number
  setSchoolCount: React.Dispatch<React.SetStateAction<number>>;
  toggledSwitches: string[];
  setToggledSwitches: React.Dispatch<React.SetStateAction<string[]>>;
}

const defaultValue: ToggledSwitchesContextType = {
  toggledSwitches: [],
  setToggledSwitches: () => {},
  schoolId:"",
  setSchoolId: () => {},
  schoolCount:0,
  setSchoolCount: () => {},
};

const ToggledSwitchesContext = createContext<ToggledSwitchesContextType>(defaultValue);

export const useToggledSwitches = (): ToggledSwitchesContextType => useContext(ToggledSwitchesContext);

export const ToggledSwitchesProvider: React.FC<{ children: ReactNode }>= ({ children }) => {
  const [toggledSwitches, setToggledSwitches] = useState<string[]>(defaultValue.toggledSwitches);
  const [schoolId,setSchoolId]=useState(defaultValue.schoolId)
  const [schoolCount,setSchoolCount]=useState(defaultValue.schoolCount)

  return (
    <ToggledSwitchesContext.Provider value={{ toggledSwitches, setToggledSwitches,schoolId,setSchoolId,schoolCount,setSchoolCount }}>
      {children}
    </ToggledSwitchesContext.Provider>
  );
};
